import { Optional } from '../../../types.js';
import { groupBy } from '../../../visualizations/common/groupBy.js';
import { optionalMin, optionalMax } from '../../common/math.js';
import { seriesTypeFlatDataset } from '../render-groups/types.js';
import { series, seriesColumnOverlapped } from '../types.js';
import { ColumnOverlappedRenderGroup, columnOverlappedRenderGroupData } from './types.js';
export const getColumnOverlappedRenderGroups = (dataset: seriesTypeFlatDataset<seriesColumnOverlapped>, series: series[]): ColumnOverlappedRenderGroup[] => {
  const columnOverlappedSeries = series.filter(x => x.type === 'column-overlapped');
  const groups = Object.values(groupBy(dataset, x => `${x.series.yTarget ?? 'left'}:${x.datapoint.key}`, x => x.datapoint.value != null));
  const collection: ColumnOverlappedRenderGroup[] = [];
  for (const group of groups) {
    const data: columnOverlappedRenderGroupData[] = [];
    let minValue: Optional<number>;
    let maxValue: Optional<number>;
    for (const entry of group) {
      if (entry.datapoint.value == null) {
        continue;
      }
      minValue = optionalMin(minValue, entry.datapoint.value);
      maxValue = optionalMax(maxValue, entry.datapoint.value);
      data.push({
        value: entry.datapoint.value,
        color: entry.series.color,
        name: entry.series.name,
        showPointLabel: entry.series.showPointLabels !== false,
        keyIndex: columnOverlappedSeries.indexOf(entry.series)
      });
    }
    collection.push({
      type: 'column-overlapped',
      yTarget: group[0].series.yTarget ?? 'left',
      minValue,
      maxValue,
      key: group[0].datapoint.key,
      data,
      keyCount: columnOverlappedSeries.length
    });
  }
  return collection;
};